// components
import MNPG from "./MNPG";
// types
import { TMainPageLayoutV3 } from "../type";


const MNPG070 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG070.rendered: ", props);

    if ( !props.template ) return null;

    return (
        <section className="section-padding-2 fix">
            <div className="container">
                <div className="news-details-area">
                    <div className="blog-post-details">
                        <div className="single-blog-post row"> 
                            <MNPG templates={props.templates} mapLayoutName={props.template.mapLayoutName} parentId={props.template.id} params={props.params} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default MNPG070;
